"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./polyfills");
// layout
require("./layout");
// style
require("@deepmap/hdm-web-map-sdk/styles/index.scss");
const system_1 = require("./util/system");
const hdm_web_map_sdk_1 = require("@deepmap/hdm-web-map-sdk");
const config = Object.assign({}, system_1.getConfig({
    projectName: 'mathematikon_basemap',
}), {
    target: 'deepMap-getting-started'
});
try {
    const map = hdm_web_map_sdk_1.DeepMapFactory.bootstrap(config);
    map.setMapViewControllerDidStart(function () {
        console.log("DeepMap initiated!");
        if (config.projectName === 'mathematikon_basemap') {
            map.moveToFeatureByOriginalSerial('hdmi_office', false, true);
        }
    });
    map.setMapViewControllerFailedStart(function (error) {
        console.log("error", error);
    });
}
catch (e) {
    console.log(e);
}
